import React, { FunctionComponent } from "react";
import styled from "styled-components";
import StepForwardTitle from "../step-forward/StepForwardTitle";
import { colours } from "@/utils";

const Hero2024Content: FunctionComponent = () => {
  return (
    <S.Section>
      <S.TitleContainer>
        <StepForwardTitle colour={colours.shell}>
          2024 <br />
          London <br />
          <S.FontWeightWrap>summit</S.FontWeightWrap>
        </StepForwardTitle>
      </S.TitleContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  background: url("/images/step-forward-2025/hero-2024.jpg");
  background-size: cover;
  display: flex;
  align-items: end;
  padding: 0 0 5% 10%;

  aspect-ratio: 2.5/1;

  @supports not (aspect-ratio: 2.5/1) {
    &::before {
      float: left;
      padding-top: 40%;
      content: "";
    }
    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }
`;

S.TitleContainer = styled.div`
  padding: 10px;
  background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.9));
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
  text-transform: uppercase;
`;

export default Hero2024Content;
